/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=43ba154c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=43ba154c&lang=css"

import exportComponent from "D:\\code\\vue\\hello_world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__